import { Button, DialogTitle, IconButton } from "@mui/material";
import Recipes, { IRecipe } from "../../shared/Recipes";
import { CloseOutlined, DeleteOutline, EditOutlined, SaveOutlined } from "@mui/icons-material";
import { useDialog } from "../../libs/dialog/DialogProvider";
import { useRef, useState } from "react";
import Confirm from "../Dialogs/Confirm";
import RecipeViewer from "./RecipeViewer";
import RecipeEditor from "./RecipeEditor";
import RecipeCache from "../../data/RecipeCache";
import { useSnackbar } from "../../libs/dialog/SnackbarProvider";

export default function RecipeDlg(props:{recipe:IRecipe}) {
    const {recipe} = props
    const {closeDialog,openDialog} = useDialog()
    const [isEdit,setEdit] = useState<boolean>(false)
    const [isValid,setIsValid] = useState<boolean>(true)
    const [isDirty,setIsDirty] = useState<boolean>(false)

    const ref = useRef<any>()
    const {setSnackbar} = useSnackbar()

    const onEdit = (e:any) => setEdit(true)
    const onDeleteConfirm = () => {

    }
    const onDelete = (e:any) => openDialog({id:"confirm",children:<Confirm message={`Are you sure you wish to delete '${props.recipe.name}?`} onConfirm={onDeleteConfirm}/>})
    const onSave = async () => {
        if (!ref.current.value) return
        try {
            RecipeCache.i.updateRecipe(recipe._id, ref.current.value)
        }catch(e){
            setSnackbar(e)
        }
    }
    const onDirty = (dirty:boolean,valid:boolean) => {
        setIsDirty(dirty)
        setIsValid(valid)
    }
    let toolbar:React.ReactElement
    let content:React.ReactElement
    if (isEdit) {
        toolbar = <>
            <Button size="small" startIcon={<CloseOutlined/>} onClick={e => setEdit(false)}>Cancel</Button>
            <Button size="small" startIcon={<SaveOutlined/>} onClick={onSave} disabled={!isValid || !isDirty}>Save</Button>
            <Button size="small" startIcon={<DeleteOutline/>} onClick={onDelete}>Delete</Button>
        </> 
        content = <RecipeEditor onDirty={onDirty} recipe={recipe} ref={ref}/>
    }
    else {
        toolbar = <>
            <Button size="small" startIcon={<EditOutlined/>} onClick={onEdit}>Edit</Button>
        </>
        content = <RecipeViewer recipe={recipe}/>
    }
    return <>
        <div className="heading flex gap-24">
            <DialogTitle>{recipe.name}</DialogTitle>
            <IconButton onClick={closeDialog} className="grid center"><CloseOutlined/></IconButton>
        </div>
        <div className="content">
            <div className="toolbar">{toolbar}</div>
            {content}
        </div>
    </>
}